import React from 'react';
import { Link } from 'react-router-dom';
import './SecondaryStatsStrip.css';

interface Kpis {
  total_test_cases: number;
  total_scenarios: number;
  total_runs: number;
  total_projects: number;
}

interface Props {
  kpis: Kpis | null;
  loading?: boolean;
}

export const SecondaryStatsStrip: React.FC<Props> = ({ kpis, loading }) => {
  const items = [
    { label: 'Test Cases', value: kpis?.total_test_cases, link: '/test-cases', tooltip: 'Total test cases in the system (all-time).' },
    { label: 'Scenarios', value: kpis?.total_scenarios, link: '/test-scenarios', tooltip: 'Total test scenarios in the system (all-time, latest version of each).' },
    { label: 'Test Runs', value: kpis?.total_runs, link: '/test-runs', tooltip: 'Test runs created in the selected period.' },
    { label: 'Projects', value: kpis?.total_projects, link: '/projects', tooltip: 'Distinct project (root folder) names across Test Case and Test Scenario trees.' },
  ];

  return (
    <div className="sss-strip">
      {items.map((item, i) => (
        <React.Fragment key={item.label}>
          {i > 0 && <span className="sss-divider" />}
          <Link to={item.link} className="sss-item" title={item.tooltip}>
            <span className="sss-value">{loading ? '—' : (item.value ?? 0).toLocaleString()}</span>
            <span className="sss-label">{item.label}</span>
          </Link>
        </React.Fragment>
      ))}
    </div>
  );
};

export default SecondaryStatsStrip;
